import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../bean/ApiResponse';

@Injectable({
  providedIn: 'root',
})
export class OAuthService {
  private httpClient: HttpClient;

  constructor(
    private handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
  }

  authorizeGoogle(state?: string) {

    let redirect: string = `${environment.login_url}`
    const authorizeParams = new URLSearchParams();
    authorizeParams.set('response_type', 'code');
    authorizeParams.set('client_id', environment.cognito_client_id);
    authorizeParams.set('redirect_uri', redirect);
    authorizeParams.set('identity_provider', 'Google');
    authorizeParams.set('scope', 'profile email openid aws.cognito.signin.user.admin');
    if (state) {
      authorizeParams.set('state', state);
    }

    const authorizeUrl = `${environment.cognito_domain}/oauth2/authorize?${authorizeParams.toString()}`;
    window.location.href = authorizeUrl;
  }

  handleAuthCallback(code: string): Observable<ApiResponse<any>> {

    if (!code) {
      throw new Error('No authorization code provided');
    }

    return this.httpClient.get<ApiResponse<any>>(`${environment.auth_services_endpoint}/token?code=${code}`);
  }
}
